import React from 'react';
import { translations } from '../translations';

const Hero = ({ language }) => {
    return (
        <section className="hero" id="home">
            <div className="hero-content">
                <h2 className="chinese-font">{translations[language]['hero.title']}</h2>
                <p className="chinese-font">{translations[language]['hero.subtitle']}</p>
                <div className="cta-buttons">
                    <a href="#demo" className="btn btn-primary">{translations[language]['hero.demoBtn']}</a>
                    <a href="#pricing" className="btn btn-secondary">{translations[language]['hero.pricingBtn']}</a>
                </div>
            </div>
        </section>
    );
};

export default Hero;
